import React, { useEffect, useState, useCallback } from 'react';
import getExperimentInfoDetails, { newExperimentInfoDetails } from './ExperimentInfo';
import {
  GetUsers,
  GetIncubTemps,
  GetSetupTemps,
  isNullOrUndefined,
  checkIsValidInput,
  setRoundedValue,
  GetContainersForExperimentInfo,
  getContainerName,
} from 'utils/Global';
import ExperimentInfoRow from './ExperimentInfoRow';
import './ExperimentInfoDetails.scss';
import { useRMSelector } from 'redux/hooks';
import { selectExpSaved, selectGlobalDataLoaded } from 'redux/selectors/StateSelectors';
import { hasModifyAccess } from 'utils/accessRights';
import { ContainersDTO } from 'business/models/Models';
import ExperimentService from 'business/services/ExperimentService';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { RMModal, useModalHandlers } from 'components/modal';
import { ModalDetails } from 'business/models/CustomModels';
import {
  setExperimentInfo,
  updateExperimentDataState,
  upsertImagingSchedule,
} from 'redux/reducers/experimentDataReducer';
import { useDispatch } from 'react-redux';
import { IStyle } from 'Styles/styleModel';
import {
  usePlateRowChangeHandler,
  usePlateColChangeHandler,
  usePlateTypeChangeHandler,
} from 'components/Experiment/hooks';
import { getPlainExperimentInfo } from 'transformers/experiment';
import EContainerType from 'enums/EContainerType';
import { PlateTypeErrorModalBody } from './PlateTypeErrorModalBody';
import { FmlxModal } from 'fmlx-common-ui';
import { UpdateGlobalDataStoreVersion } from 'business/services/GlobalService';
import { CONTAINERSSTORE } from 'utils/IndexDBGlobal';
import { setIsDirty } from 'components/customComponents/Experiment/ImagingSchedule/ImagingScheduleData';

let lastSaveCount = 0;
export default function ExperimentInfoDetails({
  setRefresh,
  experimentId,
  isScreenRoute,
}) {
  const dispatch = useDispatch();
  const exp = useRMSelector((state) => state.experiment.expData);
  const canModify = hasModifyAccess(exp?.accessRightName);
  const setExp = useCallback(
    (expData: ExperimentDtoClient) => dispatch(updateExperimentDataState(expData)),
    [dispatch],
  );
  const [expName, setExpName] = useState('');
  const [expId, setExpId] = useState<number>();
  const [reducinguL, setReducinguL] = useState(0);
  const [createdDate, setCreatedDate] = useState('');
  const [plateType, setPlateType] = useState(null);
  const [plateTypes, setPlateTypes] = useState(null);
  const [plateRowCount, setPlateRowCount] = useState(null);
  const [plateColCount, setPlateColCount] = useState(null);
  const [notes, setNotes] = useState('');
  const [noteBookPageNum, setNoteBookPageNum] = useState('');
  const [owner, setOwner] = useState(null);
  const [owners, setOwners] = useState(null);
  const [incubTemp, setIncubTemp] = useState(null);
  const [incubTemps, setIncubTemps] = useState(null);
  const [setupTemp, setsetupTemp] = useState(null);
  const [setupTemps, setsetupTemps] = useState(null);
  const [isDispensed, setIsDispensed] = useState(null);
  const [containerId, setContainerId] = useState<number>(undefined);
  const expInfo = getExperimentInfoDetails();
  const updateExpInfo = newExperimentInfoDetails();
  const globaldataloaded = useRMSelector(selectGlobalDataLoaded);
  const _selectExpSaved = useRMSelector(selectExpSaved);
  const { showModal, hideModal } = useModalHandlers();
  const [isPlateTypeUpdated, setIsPlateTypeUpdated] = useState(false);

  useEffect(() => {
    if (lastSaveCount !== _selectExpSaved) {
      lastSaveCount = _selectExpSaved;
      onSaveExp();
    }
  }, [_selectExpSaved]);

  async function onSaveExp(forceFetchExp = false) {
    await fetchAndUpdateExpInfo();
    setRefresh(true);
  }
  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: null,
    heading: '',
    isOkOnly: false,
    okButtonText: undefined,
    noButtonText: undefined,
    showButtons: true,
  });

  const onPlateRowChange = usePlateRowChangeHandler();
  const onPlateColChange = usePlateColChangeHandler();
  const onExpPlateTypeChange = usePlateTypeChangeHandler();

  function plateRowColumn() {
    const arr = [];
    for (let i = 1; i <= 35; i++) {
      arr.push(
        <option data-testid={`experimentinfodetails-options-${i}`} value={i}>
          {i}
        </option>,
      );
    }
    return arr;
  }
  function enterDetection(e) {
    if (e.which === 13 || e.keyCode === 13) {
      e.target.blur();
    }
  }
  function onChangeExperimentName(e) {
    setExpName(e.target.value);
    expInfo.IsDirty = true;
    dispatch(setExperimentInfo({ name: e.target.value }));
    updateExpInfo.name = expName;
  }

  function onChangeNotes(e) {
    setNotes(e.target.value);
    expInfo.IsDirty = true;
    dispatch(setExperimentInfo({ notes: e.target.value }));
    updateExpInfo.notes = notes;
  }

  function onChangeNoteBookPageNum(e) {
    setNoteBookPageNum(e.target.value);
    expInfo.IsDirty = true;
    dispatch(setExperimentInfo({ noteBookPageNum: e.target.value }));
    updateExpInfo.noteBookPageNum = noteBookPageNum;
  }

  function onChangeSetupTemp(e) {
    const optionElement = e.target.childNodes[e.target.selectedIndex];
    const option = optionElement.getAttribute('id');
    setsetupTemp(e.target.value);
    expInfo.IsDirty = true;
    dispatch(
      setExperimentInfo({ setupTemperature: e.target.value, setupTempId: option }),
    );
  }

  function onChangeReducingAgent(e) {
    let value = e.target.value;
    const isValid = checkIsValidInput(value);
    if (!isValid) {
      return;
    } else if (value == '.') {
      value = '0.';
    }
    const roundedVal = setRoundedValue(value, setReducinguL);
    expInfo.IsDirty = true;
    updateExpInfo.reducingAgent = roundedVal;
    dispatch(setExperimentInfo({ reducingAgent: roundedVal }));
  }

  function onChangeIncubTemp(e) {
    const optionElement = e.target.childNodes[e.target.selectedIndex];
    const option = optionElement.getAttribute('id');
    setIncubTemp(e.target.value);
    expInfo.IsDirty = true;
    dispatch(
      setExperimentInfo({ incubTemperature: e.target.value, incubTempId: option }),
    );
  }

  function onChangeOwner(e) {
    const optionElement = e.target.childNodes[e.target.selectedIndex];
    const option = optionElement.getAttribute('id');
    setOwner(e.target.value);
    dispatch(setExperimentInfo({ userName: e.target.value, userId: option }));
    expInfo.IsDirty = true;
  }

  const onPlateTypeChange = async (e) => {
    if (exp.plateDto[0]?.isoPreviousPlateID) {
      showModal({
        body: <PlateTypeErrorModalBody />,
        heading: 'Error',
        okButtonText: 'Close',
        onOk: hideModal,
        isOkOnly: true,
        size: FmlxModal.Size.MEDIUM,
        id: 'customWidthModal',
      });
      return;
    }
    const value = parseInt(e?.target?.value);
    const expService = new ExperimentService();
    const imagingScheduleId = await expService.getPlateDefaultImagingScheduleId(value);
    dispatch(
      upsertImagingSchedule({
        imagingScheduleDetails: { selectedImagingScheduleId: imagingScheduleId },
      }),
    );
    setIsDirty(true);

    onExpPlateTypeChange(value, updateExpInfo, setPlateType);
    expInfo.IsDirty = true;
  };
  const onChangePlateRow = (e) => {
    const value = parseInt(e?.target?.value);
    if (onPlateRowChange(value)) {
      setPlateRowCount(e.target.value);
    }
  };

  const onChangePlateCol = (e) => {
    const value = parseInt(e?.target?.value);
    if (onPlateColChange(value)) {
      setPlateColCount(e.target.value);
    }
  };

  useEffect(() => {
    const users = GetUsers();
    const incubationtemps = GetIncubTemps();
    const setuptemps = GetSetupTemps();
    if (!users) {
      return;
    }
    setOwners(
      users.map((user) => (
        <option key={user.id} id={user.id} value={user.name}>
          {' '}
          {user.name}{' '}
        </option>
      )),
    );
    setIncubTemps(
      incubationtemps.map((incubTemp) => (
        <option key={incubTemp.id} id={incubTemp.id} value={incubTemp.temperature}>
          {' '}
          {incubTemp.temperature}{' '}
        </option>
      )),
    );
    setsetupTemps(
      setuptemps.map((setupTemp) => (
        <option key={setupTemp.id} id={setupTemp.id} value={setupTemp.temperature}>
          {' '}
          {setupTemp.temperature}{' '}
        </option>
      )),
    );
    if (isPlateTypeUpdated) {
      const containers = GetContainersForExperimentInfo(
        containerId || exp?.info?.containerId,
        isScreenRoute
          ? [EContainerType.ScreenContainer]
          : [
              EContainerType.ExperimentContainer,
              EContainerType.LCP,
              EContainerType.Microfluidics,
            ],
      );
      setPlateTypes(
        containers.map((container) => (
          <option key={container.id} value={container.id}>
            {' '}
            {container.name}{' '}
          </option>
        )),
      );
    }
  }, [globaldataloaded, containerId, exp?.info?.containerId, isPlateTypeUpdated]);

  useEffect(() => {
    async function fetchData() {
      const data = await fetchAndUpdateExpInfo();
      if (data === null) {
        return null;
      }
      const incubTemperature = {
        id: data.incubTempId,
        temperature: data.incubTemperature,
      };
      const setupTemperature = {
        id: data.setupTempId,
        temperature: data.setupTemperature,
      };
      const container = { id: data.containerId, type: data.plateType };
      const user = { id: data.userId, name: data.userName };
      expInfo.setExperimentInfoDetails(
        data.id,
        data.name,
        incubTemperature,
        setupTemperature,
        user,
        container,
        data.plateRowCount,
        data.plateColCount,
        data.seeding,
        data.reducingAgent,
        data.notes,
        data.noteBookPageNum,
        data.dispensingRobotId,
      );
    }
    function fetchFromState() {
      setOwner(exp.info.userName);
      setsetupTemp(exp.info.setupTemperature);
      setIncubTemp(exp.info.incubTemperature);
      setExpName(exp.info.name);
      setExpId(exp.info.id);
      setReducinguL(exp.info.reducingAgent);
      setCreatedDate(exp.info.dateCreated);
      const containers = GetContainersForExperimentInfo(
        containerId || exp?.info?.containerId,
        isScreenRoute
          ? [EContainerType.ScreenContainer]
          : [
              EContainerType.ExperimentContainer,
              EContainerType.LCP,
              EContainerType.Microfluidics,
            ],
      ) as ContainersDTO[];
      setPlateType(containers?.find((c) => c.id === exp.info.containerId)?.id);
      setPlateRowCount(exp.info.plateRowCount);
      setPlateColCount(exp.info.plateColCount);
      setNotes(exp.info.notes === null ? '' : exp.info.notes);
      setNoteBookPageNum(
        exp.info.noteBookPageNum === null ? '' : exp.info.noteBookPageNum,
      );
      setIsDispensed(exp.info.isDispensed);
      setIsPlateTypeUpdated(true);
    }
    if (isNullOrUndefined(exp.info)) {
      fetchData();
    } else {
      fetchFromState();
    }
  }, [exp]);

  const updateContainerName = async (containerName: string | undefined) => {
    if (
      !isNullOrUndefined(containerName) &&
      containerName !== getContainerName(plateType)
    ) {
      await UpdateGlobalDataStoreVersion([CONTAINERSSTORE.name]);
    }
    setIsPlateTypeUpdated(true);
  };

  const fetchAndUpdateExpInfo = async () => {
    const expService = new ExperimentService();
    const data = getPlainExperimentInfo(await expService.getExperimentInfo(experimentId));
    if (!data) {
      return null;
    }
    const expData = { ...exp, info: { ...exp.info } };
    expData.info = { ...data };
    expData.expName = data.name;
    if (containerId === undefined) {
      setContainerId(data.containerId || expData.info.containerId);
    }
    await updateContainerName(data.plateType); // Make sure that container name is up to date (data.plateType is always up-to-date)
    setExp(expData as ExperimentDtoClient);
    return data;
  };
  function isPlateTypeDisabled() {
    if (isDispensed || !canModify) {
      return true;
    }
    return false;
  }

  const onReducingAgentBlur = () => {
    if (!reducinguL) {
      setReducinguL(0);
    }
  };

  function mainBody() {
    return (
      <>
        <RMModal
          id="experimentinfodetails-mainbody-modal"
          data-testid="experimentinfodetails-mainbody-modal"
          showModal={modalDetails.showModal}
          setShowModal={() => setModalDetails({ ...modalDetails, showModal: false })}
          onOk={() => setModalDetails({ ...modalDetails, showModal: false })}
          body={modalDetails.body}
          heading={modalDetails.heading}
          isOkOnly={modalDetails.isOkOnly}
          okButtonText={modalDetails.okButtonText}
        />
        <div
          id="experimentinfodetails-mainbody-wrapper"
          data-testid="experimentinfodetails-mainbody-wrapper"
          style={{ height: '90%' }}
        >
          <div
            id="experimentinfodetails-mainbody-content"
            data-testid="experimentinfodetails-mainbody-content"
          >
            <ExperimentInfoRow
              id="experimentinfodetails-name-row"
              data-testid="experimentinfodetails-name-row"
              text={isScreenRoute ? 'Screen Name' : 'Experiment Name'}
              className="col-md-6"
            >
              <input
                id="experimentinfodetails-name-input"
                data-testid="experimentinfodetails-name-input"
                className="inputFieldDetails"
                onKeyUp={enterDetection}
                onChange={onChangeExperimentName}
                value={expName}
                disabled={!canModify}
              />
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-id-row"
              data-testid="experimentinfodetails-id-row"
              text={isScreenRoute ? 'Screen ID' : 'Experiment ID'}
              className="col-md-6"
            >
              <input
                id="experimentinfodetails-id-input"
                data-testid="experimentinfodetails-id-input"
                className="inputFieldWithBackground"
                value={expId}
                disabled
              />
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-datecreated-row"
              data-testid="experimentinfodetails-datecreated-row"
              text="Date Created"
              className="col-md-6"
            >
              <input
                id="experimentinfodetails-datecreated-input"
                data-testid="experimentinfodetails-datecreated-input"
                className="inputFieldWithBackground"
                value={createdDate}
                disabled
              />
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-platetype-row"
              data-testid="experimentinfodetails-platetype-row"
              text="Plate Type"
              className="col-md-6"
            >
              <select
                name="plateType"
                id="plateType"
                data-testid="experimentinfodetails-platetype-select"
                disabled={isPlateTypeDisabled()}
                onChange={onPlateTypeChange}
                value={isPlateTypeUpdated ? plateType : undefined}
                className="inputFieldDetails"
              >
                {plateTypes}
              </select>
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-rowcol-row"
              data-testid="experimentinfodetails-rowcol-row"
              text="Plate Row and Column"
              className="col-md-6"
            >
              <div
                id="experimentinfodetails-rowcol-wrapper"
                data-testid="experimentinfodetails-rowcol-wrapper"
                className="d-flex align-items-center"
              >
                <div className="col-md-6 padding0">
                  <select
                    name="plateRow"
                    id="plateRow"
                    data-testid="experimentinfodetails-plate-row-select"
                    disabled={isPlateTypeDisabled()}
                    onChange={onChangePlateRow}
                    value={plateRowCount}
                    className="customDetailsInputs"
                  >
                    {plateRowColumn()}
                  </select>
                </div>
                <div className="col-md-6 padding0">
                  <select
                    name="plateCol"
                    id="plateCol"
                    data-testid="experimentinfodetails-plate-col-select"
                    disabled={isPlateTypeDisabled()}
                    onChange={onChangePlateCol}
                    value={plateColCount}
                    style={{
                      fontWeight: 400,
                      fontSize: 13,
                      float: 'right',
                      width: '75%',
                      padding: 5,
                    }}
                  >
                    {plateRowColumn()}
                  </select>
                </div>
              </div>
            </ExperimentInfoRow>

            <ExperimentInfoRow
              id="experimentinfodetails-setuptemp-row"
              data-testid="experimentinfodetails-setuptemp-row"
              text="Setup Temperature (°C)"
              className="col-md-3"
            >
              <select
                name="plateRow"
                id="plateRow"
                data-testid="experimentinfodetails-platerow-setuptemp-select"
                onChange={onChangeSetupTemp}
                disabled={!canModify}
                value={setupTemp}
                className="customDetailsInputs"
              >
                {setupTemps}
              </select>
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-incubtemp-row"
              data-testid="experimentinfodetails-incubtemp-row"
              text="Incubation Temperature (°C)"
              className="col-md-3"
            >
              <select
                name="plateRow"
                id="plateRow"
                data-testid="experimentinfodetails-platerow-incubtemp-select"
                onChange={onChangeIncubTemp}
                disabled={!canModify}
                value={incubTemp}
                className="customDetailsInputs"
              >
                {incubTemps}
              </select>
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-reducingagent-row"
              data-testid="experimentinfodetails-reducingagent-row"
              text="Reducing Agent (uL)"
              className="col-md-3"
            >
              <input
                id="experimentinfodetails-reducingagent-input"
                data-testid="experimentinfodetails-reducingagent-input"
                onChange={onChangeReducingAgent}
                className="customDetailsInputs"
                value={reducinguL}
                onBlur={onReducingAgentBlur}
                disabled={!canModify}
              />
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-notebookpage-row"
              data-testid="experimentinfodetails-notebookpage-row"
              text="Notebook Page"
              className="col-md-3"
            >
              <input
                id="experimentinfodetails-notebookpage-input"
                data-testid="experimentinfodetails-notebookpage-input"
                onChange={onChangeNoteBookPageNum}
                className="customDetailsInputs"
                value={noteBookPageNum}
                disabled={!canModify}
              />
            </ExperimentInfoRow>
            <ExperimentInfoRow
              id="experimentinfodetails-owner-row"
              data-testid="experimentinfodetails-owner-row"
              text="Owner"
              className="col-md-6"
            >
              <select
                name="notebook"
                id="notebook"
                data-testid="experimentinfodetails-owner-notebook-select"
                onChange={onChangeOwner}
                value={owner}
                className="ownerDetail"
                disabled={!canModify}
              >
                {owners}
              </select>
            </ExperimentInfoRow>
          </div>
          <div
            id="experimentinfodetails-notes-header"
            data-testid="experimentinfodetails-notes-header"
            className="row margin0"
          >
            <div
              id="experimentinfodetails-notes-header-title"
              data-testid="experimentinfodetails-notes-header-title"
              className="col-md-6 notes"
            >
              Notes
            </div>
          </div>
          <div
            id="experimentinfodetails-notes-wrapper"
            data-testid="experimentinfodetails-notes-wrapper"
            className="row margin0"
            style={{ height: '32vh' }}
          >
            <div
              id="experimentinfodetails-notes"
              data-testid="experimentinfodetails-notes"
              className="col-md-12 notesOwnerCommon"
            >
              <textarea
                id="experimentinfodetails-notes-textarea"
                data-testid="experimentinfodetails-notes-textarea"
                className="changeNotes selection:bg-blue-500 selection:text-white"
                onChange={onChangeNotes}
                value={notes}
                disabled={!canModify}
              >
                {notes}
              </textarea>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div
        id="experimentinfodetails-wrapper"
        data-testid="experimentinfodetails-wrapper"
        style={styles.root}
      >
        {isScreenRoute ? 'Screen Info' : 'Experiment Info'}
      </div>
      {mainBody()}
    </>
  );
}

const styles: IStyle = {
  root: {
    fontWeight: 700,
    color: '#F7A246',
    padding: '15px 10px',
    background: '#E4E4E4',
  },
};
